// Tetikleyici kosullarinin degerlendirilmesi. Trigger sinifindan cikarildi ki
// tarayici olmadan test edilebilsin. CommonJS: webpack de node --test de okuyabilsin diye.

const { matchSdkData } = require("./triggerCoerce.js");

const DAYS = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
};

const OPERATORS = {
    equal: (a, b) => a === b,
    not_equal: (a, b) => a !== b,
    less_than: (a, b) => a < b,
    greater_than: (a, b) => a > b,
    less_than_or_equal: (a, b) => a <= b,
    greater_than_or_equal: (a, b) => a >= b,
    contains: (a, b) => a.includes(b),
    not_contains: (a, b) => !a.includes(b),
};

// Motorda karsiligi olmayan kosullar: panelde secilebiliyorlar ama eslesmeyi
// daraltmiyorlar. Panel bunlari kullaniciya uyari olmadan sunmamali.
const UNIMPLEMENTED_CONDITIONS = ["visitorName", "department"];

const str = (v) => (typeof v === "string" ? v : v === undefined || v === null ? "" : String(v));

const VISIT_WINDOW_MS = 30 * 60 * 1000;

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign"];

// Referrer ve URL'deki utm parametrelerini tek nesnede toplar. Bozuk url'de bos doner.
function buildTrafficSource(referrer, pageUrl) {
    const out = { referrer: str(referrer), utm_source: "", utm_medium: "", utm_campaign: "" };
    const url = str(pageUrl);
    const q = url.indexOf("?");
    if (q === -1) return out;
    const pairs = url.slice(q + 1).split("&");
    for (let i = 0; i < pairs.length; i++) {
        const eq = pairs[i].indexOf("=");
        if (eq === -1) continue;
        const k = pairs[i].slice(0, eq);
        if (UTM_KEYS.indexOf(k) === -1) continue;
        try {
            out[k] = decodeURIComponent(pairs[i].slice(eq + 1).replace(/\+/g, " "));
        } catch (e) {
            out[k] = pairs[i].slice(eq + 1);
        }
    }
    return out;
}

// Yeni ziyaret: son ziyaretten bu yana 30 dk gectiyse sayac artar, sekmeden bagimsiz.
function computeVisitCount(storedCount, lastVisitTs, now, windowMs) {
    const w = typeof windowMs === "number" ? windowMs : VISIT_WINDOW_MS;
    let count = parseInt(storedCount, 10);
    if (isNaN(count) || count < 1) count = 0;
    const last = parseInt(lastVisitTs, 10);
    const isNewVisit = isNaN(last) || now - last > w;
    if (isNewVisit) count += 1;
    return { count: count || 1, isNewVisit: isNewVisit, lastVisitTs: now };
}

// Tek kosulu degerlendirir. Bilinmeyen kosul tipi eslesmeyi daraltmaz (eski davranis),
// bilinmeyen operator ise eslesmez - eskiden TypeError firlatip tick'i kirardi.
function matchCondition(rule, ctx) {
    const r = rule || {};
    const c = ctx || {};
    const op = OPERATORS[r.operator];

    switch (r.condition) {
        case "dayTime": {
            if (!op) return false;
            const raw = str(r.value);
            // Yeni kayitlar "HH:MM", eski kayitlar duz saat ("9") yazar.
            if (raw.indexOf(":") !== -1) {
                const parts = raw.split(":");
                const h = parseInt(parts[0], 10);
                const m = parseInt(parts[1], 10);
                if (isNaN(h) || isNaN(m)) return false;
                return op(c.minuteOfDay, h * 60 + m);
            }
            const hour = parseInt(raw, 10);
            if (isNaN(hour)) return false;
            return op(c.hour, hour);
        }
        case "weekDay":
            return !!op && Object.prototype.hasOwnProperty.call(DAYS, r.value) && op(c.day, DAYS[r.value]);
        case "spendTimePage":
            return !!op && op(c.pageSeconds, parseInt(r.value));
        case "spendTimeSite":
            return !!op && op(c.siteSeconds, parseInt(r.value));
        case "pageUrl":
            return !!op && op(str(c.pageUrl), str(r.value));
        case "pageTitle":
            return !!op && op(str(c.title), str(r.value));
        case "systemStatus":
            return !!op && op(!c.offlineMode, r.value === "true");
        case "deviceType":
            return !!op && op(str(c.deviceType), str(r.value));
        case "visitCount": {
            if (!op) return false;
            const target = parseInt(r.value, 10);
            if (isNaN(target)) return false;
            return op(c.visitCount, target);
        }
        case "sdkData":
            return !!op && matchSdkData(c.triggerData, { key: r.key, operator: r.operator, value: r.value }, OPERATORS);
        case "trafficSource": {
            if (!op) return false;
            const src = c.trafficSource || {};
            const key = r.key || "referrer";
            return op(str(src[key]), str(r.value));
        }
        case "visitorLocale": {
            if (!op) return false;
            const locale = c.locale || {};
            const key = r.key === "country" ? "country" : "language";
            const actual = str(locale[key]).toLowerCase();
            if (!actual) return false;
            return op(actual, str(r.value).toLowerCase());
        }
        case "visitorName":
        case "department":
            // Henuz uygulanmadi; eslesmeyi daraltmaz.
            return true;
        default:
            return true;
    }
}

// Tum kosullar VE'lenir. Bozuk eleman digerlerini bozmaz.
function matchConditions(conditions, ctx) {
    if (!Array.isArray(conditions) || !conditions.length) return true;
    return conditions.every((rule) => (rule && typeof rule === "object" ? matchCondition(rule, ctx) : true));
}

module.exports = { matchCondition, matchConditions, buildTrafficSource, OPERATORS, DAYS, UNIMPLEMENTED_CONDITIONS, computeVisitCount, VISIT_WINDOW_MS };



// WEBPACK FOOTER //
// ./src/utils/triggerConditions.js